export default import.meta.ROLLUP_FILE_URL_F32zlqQFKXYzQTbhRY79xw